import { Module } from 'vuex-module-decorators'
import SalesCartAbstract from '~/store/sales-cart-abstract'

@Module({
  name: 'sales-cart-proposal',
  stateFactory: true,
  namespaced: true,
})
export default class SalesCartProposal extends SalesCartAbstract {}
